'use strict'

import React from 'react';

const FormDropdown = ({ input, children }) => {
  const colorClasses = 'onsched-border-border-color onsched-dark-color onsched-primary-border-color-hover';

  return (
    <div
      className={`${colorClasses} ${input.className ? input.className : ''} FormInput FormDropdown`} 
      label={input.label}
      tooltip="lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar "
    >
      <select 
        className='onsched-primary-border-color-active onsched-primary-border-color-focus'
        name={input.name}
      >
        { children }
      </select>
    </div>
  )
}

export default FormDropdown
